"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function TheManOfTheHour() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 30;
      const y = (e.clientY / window.innerHeight - 0.5) * 30;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="223661" id="our-local-roots" className="bg-background text-foreground relative min-h-screen flex items-center overflow-hidden" style={{
    perspective: "1000px"
  }}>
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes flyGlow {
            0%, 100% { 
              text-shadow: 0 0 20px hsl(var(--primary) / 0.2), 0 0 40px hsl(var(--primary) / 0.1);
              transform: scale(1) translateY(0);
            }
            50% { 
              text-shadow: 0 0 30px hsl(var(--primary) / 0.4), 0 0 60px hsl(var(--primary) / 0.2);
              transform: scale(1.01) translateY(-5px);
            }
          }
          .animate-float {
            animation: float 6s ease-in-out infinite;
          }
          .animate-fly-glow {
            animation: flyGlow 4s ease-in-out infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-0 transition-transform duration-300 ease-out" style={{
      transform: `rotateX(${-mousePosition.y}deg) rotateY(${mousePosition.x}deg) scale(1.1)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/industrial_geometric_octagon_pattern.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/industrial_geometric_octagon_pattern.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/industrial_geometric_octagon_pattern.png-wvc-sizes" alt="" className="w-[120vw] md:w-[80vw] max-w-[1000px] object-contain opacity-10 blur-[1px]" aria-hidden="true" loading="lazy" />
      </div>

      <div className="container mx-auto px-4 py-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-12">
            <div className="space-y-6">
              <h1 className="font-default text-7xl md:text-8xl lg:text-[86px] leading-[0.85] tracking-tighter uppercase animate-fly-glow text-primary">
                Deeply Rooted in Punta Gorda Heritage and Local Pest Expertise
              </h1>
              <h2 className="font-default text-3xl md:text-[42px] leading-tight uppercase text-foreground">As a family-owned part of the Punta Gorda community, we understand that local soil and Florida's unique seasonal patterns require specialized knowledge. we bring the experience navigating neighborhood-specific pest pressures, ensuring your home or business remains a sanctuary through every climate shift in our beloved city.</h2>
            </div>
            
            <div className="pt-8">
              <Link to="/ContactPage">
                <Button size="lg" className="h-14 px-8 text-lg font-default font-bold tracking-wider uppercase rounded-lg bg-primary text-primary-foreground hover:scale-105 transition-all duration-300 group">
                  Free Inspection
                  <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-lg mx-auto lg:max-w-none animate-float">
            {}
            <div className="absolute -inset-4 bg-primary/20 blur-[60px] rounded-lg z-0 pointer-events-none"></div>
            <div className="absolute -inset-1 bg-foreground/5 blur-[30px] z-0 pointer-events-none"></div>
            
            {}
            <div className="relative z-10 overflow-hidden border-2 border-foreground bg-card aspect-[4/5] md:aspect-square lg:aspect-[4/5]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/professional_pest_control_service_truck.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/professional_pest_control_service_truck.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/professional_pest_control_service_truck.png-wvc-sizes" alt="Peace River Pest Control Service Vehicle" className="w-full h-full object-cover object-center" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}